module.exports = __webpack_public_path__ + "static/xxpeed-xp-1-6d9705a98937393714d94d19dd839f35.jpg";